import {
  ADDRBOOK_LOADING,
  ADDRBOOK_FAILED,
  ADDRBOOK_CREATED,
  ADDRBOOK_EDITED,
  ADDRBOOK_SEARCH,
  ADDRBOOK_DELETE,
  ADDRBOOK_LOADED,
  ADDRPHONE_CREATED,
  ADDRPHONE_SEARCH,
  ADDRPHONE_LOADED,
  ADDRPHONE_DELETE,
  ADDRPHONE_EDIT,
  CAMPAIGN_LOADED,
  CAMPAIGN_SEARCH,
  CAMPAIGN_CREATED,
  CAMPAIGN_DELETE,
  CAMPAIGN_EDIT,
  ADDRBOOK_DEFAULT,
  LOGOUT,
  AUTH_FAILED,
} from "../types";

import {
  created,
  editedUpdate,
  deleteFromState,
} from "../../helpers/reduxUtils";

const initiateState = {
  addrGrps: [],
  campaigns: [],
  campaignsSearch: [],
  addrGrpsSearch: [],
  addrPhonesSearch: [],
  addrPhones: [],
  bulkPhoneUploaded: false,
  isLoading: false,
  defaultGroup: null,
};

export default function (state = initiateState, action) {
  switch (action.type) {
    case ADDRBOOK_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case ADDRBOOK_DEFAULT:
      return {
        ...state,
        isLoading: false,
        defaultGroup: action.payload,
      };
    case CAMPAIGN_DELETE:
      return {
        ...state,
        isLoading: false,
        campaigns: deleteFromState(state.campaigns, action.payload),
      };
    case CAMPAIGN_EDIT:
      return {
        ...state,
        isLoading: false,
        campaigns: editedUpdate(state.campaigns, action.payload),
      };
    case CAMPAIGN_CREATED:
      return {
        ...state,
        isLoading: false,
        campaigns: created(state.campaigns, action.payload),
      };
    case CAMPAIGN_SEARCH:
      return {
        ...state,
        isLoading: false,
        campaignsSearch: action.payload,
      };
    case CAMPAIGN_LOADED:
      return {
        ...state,
        isLoading: false,
        campaigns: action.payload,
      };

    case ADDRPHONE_EDIT:
      return {
        ...state,
        isLoading: false,
        bulkPhoneUploaded: false,
        addrPhones: editedUpdate(state.addrPhones, action.payload),
      };
    case ADDRPHONE_DELETE:
      return {
        ...state,
        isLoading: false,
        bulkPhoneUploaded: false,
        addrPhones: deleteFromState(state.addrPhones, action.payload),
      };

    case ADDRPHONE_LOADED:
      return {
        ...state,
        isLoading: false,
        bulkPhoneUploaded: false,
        addrPhones: action.payload,
      };
    case ADDRPHONE_SEARCH:
      return {
        ...state,
        isLoading: false,
        bulkPhoneUploaded: false,
        addrPhonesSearch: action.payload,
      };
    case ADDRPHONE_CREATED:
      return {
        ...state,
        isLoading: false,
        bulkPhoneUploaded: true,
        addrPhones: created(state.addrPhones, action.payload),
      };
    case ADDRBOOK_LOADED:
      return {
        ...state,
        isLoading: false,
        addrGrps: action.payload,
      };
    case ADDRBOOK_SEARCH:
      return {
        ...state,
        isLoading: false,
        addrGrpsSearch: action.payload,
      };
    case ADDRBOOK_DELETE:
      return {
        ...state,
        isLoading: false,
        addrGrps: deleteFromState(state.addrGrps, action.payload),
      };
    case ADDRBOOK_EDITED:
      return {
        ...state,
        isLoading: false,
        addrGrps: editedUpdate(state.addrGrps, action.payload),
      };
    case ADDRBOOK_CREATED:
      return {
        ...state,
        isLoading: false,
        addrGrps: created(state.addrGrps, action.payload),
      };
    case ADDRBOOK_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case AUTH_FAILED:
    case LOGOUT:
      return initiateState;
    default:
      return state;
  }
}
